import React, { useMemo, useState } from "react";
import {
  FaHeart,
  FaStar,
  FaMountain,
  FaTint,
  FaSeedling,
  FaCoffee,
  FaFire,
  FaShippingFast,
  FaMinus,
  FaPlus,
  FaCheckCircle,
} from "react-icons/fa";

const origins = ["Rulindo", "Kamonyi", "Karongi"];

const sizes = [
  { id: "250g", label: "250g", price: 6500 },
  { id: "500g", label: "500g", price: 12000 },
  { id: "1kg", label: "1kg", price: 22000 },
];

const notes = [
  { name: "Citrus", color: "bg-[#E8C96A]" },
  { name: "Chocolate", color: "bg-[#5C3A21]" },
  { name: "Brown Sugar", color: "bg-[#B07A3A]" },
];

const profile = [
  { label: "Acidity", value: 80 },
  { label: "Sweetness", value: 80 },
  { label: "Body", value: 60 },
  { label: "Bitterness", value: 20 },
];

const alsoBuy = [
  { title: "Whole Beans 1kg", price: "22,000 Frw", image: "/kbl-bag.png" },
  { title: "Ground 500g", price: "12,000 Frw", image: "/kbl-bag.png" },
  { title: "Gift Pack 250g", price: "6,500 Frw", image: "/kbl-bag.png" },
];

const FeaturedProduct = () => {
  const [origin, setOrigin] = useState("Rulindo");
  const [form, setForm] = useState("whole");
  const [size, setSize] = useState("250g");
  const [grind, setGrind] = useState("Medium (Drip / Pour Over)");
  const [qty, setQty] = useState(1);
  const [saved, setSaved] = useState(false);

  const price = useMemo(
    () => sizes.find((s) => s.id === size)?.price ?? 6500,
    [size]
  );

  const orderWhatsApp = () => {
    const message = `New KBL Coffee Order

Product: ${origin} Medium Roast (Single Origin)
Form: ${form === "whole" ? "Whole Bean" : "Ground"}
${form === "ground" ? `Grind: ${grind}\n` : ""}Size: ${size}
Quantity: ${qty}
Origin: ${origin}, Rwanda
Price: RWF ${(price * qty).toLocaleString()}

Brewed with purpose. Shared with pride.`;
    window.open(
      `https://wa.me/250787255672?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <section id="shop" className="bg-cream px-4 py-14 sm:px-6 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-[0.9fr_1.1fr_0.85fr] lg:items-start lg:gap-8 xl:gap-10">
        <div className="overflow-hidden rounded-2xl bg-[#F1EBE3] sm:rounded-3xl">
          <img
            src="/kbl-bag.png"
            alt={`KBL Coffee 250g bag — single-origin ${origin} Arabica`}
            className="mx-auto w-full max-w-lg object-cover object-center transition duration-700 hover:-translate-y-1"
          />
        </div>

        <div className="min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
            Single Origin
          </p>
          <h2 className="mt-2 font-display text-3xl text-espresso sm:text-4xl">
            {origin} Medium Roast
          </h2>
          <p className="mt-3 text-base leading-relaxed text-cocoa">
            Bright and balanced with notes of citrus, chocolate and brown sugar.
            Each bag is from one district—never blended across origins.
          </p>

          <div className="mt-4 flex flex-wrap items-center gap-3 text-sm">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 font-medium text-emerald-800">
              <FaCheckCircle className="text-emerald-600" /> In stock
            </span>
            <span className="inline-flex items-center gap-1.5 text-cocoa">
              <FaFire className="text-gold" /> Roast date: 10 Jul 2026
            </span>
            <span className="inline-flex items-center gap-1.5 text-cocoa">
              <FaShippingFast className="text-gold" /> Ships tomorrow
            </span>
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-semibold text-espresso">Origin</p>
            <div className="flex flex-wrap gap-2">
              {origins.map((o) => (
                <button
                  key={o}
                  type="button"
                  onClick={() => setOrigin(o)}
                  className={`rounded-md px-4 py-2.5 text-sm font-semibold transition ${
                    origin === o
                      ? "bg-espresso text-cream"
                      : "border border-cream-muted bg-white text-espresso hover:border-espresso"
                  }`}
                >
                  {o}
                </button>
              ))}
            </div>
            <p className="mt-2 text-xs text-cocoa">
              Choose one single origin per order—Rulindo, Kamonyi, or Karongi.
            </p>
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-semibold text-espresso">Roast Level</p>
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((n) => (
                <span
                  key={n}
                  className={`h-3.5 w-3.5 rounded-full ${
                    n <= 3 ? "bg-espresso" : "border border-cream-muted bg-transparent"
                  }`}
                />
              ))}
              <span className="ml-2 text-sm text-cocoa">Medium</span>
            </div>
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-semibold text-espresso">Bean / Ground</p>
            <div className="flex gap-2">
              {[
                { id: "whole", label: "Whole Bean" },
                { id: "ground", label: "Ground" },
              ].map((opt) => (
                <button
                  key={opt.id}
                  type="button"
                  onClick={() => setForm(opt.id)}
                  className={`rounded-md px-5 py-2.5 text-sm font-semibold transition ${
                    form === opt.id
                      ? "bg-espresso text-cream"
                      : "border border-cream-muted bg-white text-espresso hover:border-espresso"
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          <div className="mt-4">
            <label className="mb-2 block text-sm font-semibold text-espresso">
              Grind Size
            </label>
            <select
              value={grind}
              onChange={(e) => setGrind(e.target.value)}
              disabled={form === "whole"}
              className="w-full max-w-sm rounded-md border border-cream-muted bg-white px-4 py-2.5 text-sm outline-none focus:border-gold disabled:opacity-45"
            >
              <option>Fine (Espresso)</option>
              <option>Medium (Drip / Pour Over)</option>
              <option>Medium-Coarse</option>
              <option>Coarse (French Press)</option>
            </select>
          </div>

          <div className="mt-5">
            <p className="mb-2 text-sm font-semibold text-espresso">Size</p>
            <div className="flex gap-2">
              {sizes.map((s) => (
                <button
                  key={s.id}
                  type="button"
                  onClick={() => setSize(s.id)}
                  className={`min-w-[4.75rem] rounded-md px-4 py-2.5 text-sm font-semibold transition ${
                    size === s.id
                      ? "bg-espresso text-cream"
                      : "border border-cream-muted bg-white text-espresso hover:border-espresso"
                  }`}
                >
                  {s.label}
                </button>
              ))}
            </div>
          </div>

          <div className="mt-5">
            <p className="mb-2 text-sm font-semibold text-espresso">Quantity</p>
            <div className="inline-flex items-center rounded-md border border-cream-muted bg-white">
              <button
                type="button"
                aria-label="Decrease quantity"
                onClick={() => setQty((q) => Math.max(1, q - 1))}
                className="px-3 py-2.5 text-espresso hover:bg-cream"
              >
                <FaMinus className="text-xs" />
              </button>
              <span className="min-w-[2.5rem] text-center text-sm font-semibold">{qty}</span>
              <button
                type="button"
                aria-label="Increase quantity"
                onClick={() => setQty((q) => q + 1)}
                className="px-3 py-2.5 text-espresso hover:bg-cream"
              >
                <FaPlus className="text-xs" />
              </button>
            </div>
          </div>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
            <p className="font-display text-3xl text-espresso">
              RWF {(price * qty).toLocaleString()}
            </p>
            <button
              type="button"
              onClick={orderWhatsApp}
              className="w-full rounded-md bg-espresso px-7 py-3 text-sm font-semibold text-cream transition hover:bg-espresso-soft sm:w-auto"
            >
              Add to Cart
            </button>
            <button
              type="button"
              onClick={() => setSaved((v) => !v)}
              className={`flex h-11 w-11 items-center justify-center rounded-md border transition ${
                saved
                  ? "border-gold bg-gold/15 text-gold"
                  : "border-cream-muted text-espresso hover:border-gold hover:text-gold"
              }`}
              aria-label="Wishlist"
            >
              <FaHeart />
            </button>
          </div>
        </div>

        <aside className="rounded-2xl bg-[#EFE9E1] p-6">
          <div className="flex items-center gap-2 text-gold">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="text-sm" />
            ))}
            <span className="text-sm text-cocoa">(126 reviews)</span>
          </div>

          <h3 className="mt-6 font-display text-lg text-espresso">Tasting Notes</h3>
          <div className="mt-4 flex justify-between gap-2">
            {notes.map((note) => (
              <div key={note.name} className="flex-1 text-center">
                <div className={`mx-auto mb-2 h-11 w-11 rounded-full ${note.color}`} />
                <p className="text-[11px] font-medium text-cocoa">{note.name}</p>
              </div>
            ))}
          </div>

          <h3 className="mt-8 font-display text-lg text-espresso">Roast Profile</h3>
          <div className="mt-4 space-y-3">
            {profile.map((item) => (
              <div key={item.label}>
                <div className="mb-1 text-xs text-cocoa">{item.label}</div>
                <div className="h-2 rounded-full bg-cream">
                  <div
                    className="h-2 rounded-full bg-espresso"
                    style={{ width: `${item.value}%` }}
                  />
                </div>
              </div>
            ))}
          </div>

          <ul className="mt-8 space-y-3.5 text-sm text-cocoa">
            <li className="flex items-start gap-3">
              <FaMountain className="mt-0.5 shrink-0 text-gold" />
              <span><strong className="text-espresso">Origin:</strong> {origin} (single origin)</span>
            </li>
            <li className="flex items-start gap-3">
              <FaMountain className="mt-0.5 shrink-0 text-gold" />
              <span><strong className="text-espresso">Altitude:</strong> 1,500–2,000 MASL</span>
            </li>
            <li className="flex items-start gap-3">
              <FaTint className="mt-0.5 shrink-0 text-gold" />
              <span><strong className="text-espresso">Process:</strong> Washed</span>
            </li>
            <li className="flex items-start gap-3">
              <FaSeedling className="mt-0.5 shrink-0 text-gold" />
              <span><strong className="text-espresso">Variety:</strong> Red Bourbon</span>
            </li>
            <li className="flex items-start gap-3">
              <FaCoffee className="mt-0.5 shrink-0 text-gold" />
              <span><strong className="text-espresso">Best for:</strong> Filter, Pour Over, Espresso</span>
            </li>
          </ul>
        </aside>
      </div>

      <div className="mx-auto mt-14 max-w-7xl">
        <h3 className="font-display text-2xl text-espresso">Customers also buy</h3>
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          {alsoBuy.map((item) => (
            <a
              key={item.title}
              href="#shop"
              className="flex items-center gap-4 rounded-2xl border border-cream-muted bg-white p-4 transition hover:border-gold"
            >
              <img src={item.image} alt="" className="h-16 w-16 rounded-lg object-cover" />
              <div>
                <p className="font-semibold text-espresso">{item.title}</p>
                <p className="text-sm text-cocoa">{item.price}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProduct;
